import { CatHeading } from '@blocks-react/components/Heading';
import { BestSellerHeadingProps } from '../types';
export const BestSellerHeading = ({
  children,
  ...headingProps
}: BestSellerHeadingProps) => {
  return (
    <CatHeading variant='headline' {...headingProps}>{children}</CatHeading>
  );
};
